import { Button, Form, Input, Modal, message } from "antd";
import { ModalHeader } from "datastake-daf/dist/components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components"
import Loading from "../../../Loading";
import AmpService from "../../../../services/AmpService";
import { copyToClipboard } from "../../../../helpers/copyToClipboard";

const Style = styled.div`
  .buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
  }

  p {
    margin-bottom: 32px;
  }
`;

export default function InviteAmp({
  ampToInvite,
  setAmpToInvite,
  refreshData = () => { },
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [code, setCode] = useState();
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);

    try {
      const _data = await form.validateFields();

      const { data } = await AmpService.inviteAmp({
        ..._data,
        id: ampToInvite.dbId,
      })

      if (typeof data === 'string') {
        message.error(data);
        setLoading(false);
        return;
      }

      if (data.invitationLink) {
        setCode(data.invitationLink);
      } else {
        message.success(t('Invitation has been successfully sent.'));
        setAmpToInvite(null);
        refreshData();
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!ampToInvite) {
      form.resetFields();
    } else {
      if (ampToInvite?.ampInvited?.invitationToken) {
        setCode(`${window.location.origin}/tif/register?code=${ampToInvite?.ampInvited?.invitationToken}`);
      }
    }
  }, [ampToInvite]);

  const copyCode = () => {
    const copyText = document.getElementById("myInput");
    copyText.value = code;
    copyToClipboard('myInput')
  }

  return (
    <Modal
      open={!!ampToInvite}
      title={<ModalHeader title={t('Invite Amp')} />}
      footer={null}
      width={650}
      onCancel={() => setAmpToInvite(null)}
    >
      <Style>
        <input id="myInput" hidden />
        {code ? (
          <div>
            <p>
              {t('This AMP have already been invited by you, copy the invitation link and reach out to them.')}
            </p>
            <div className="buttons">
              <Button onClick={() => setAmpToInvite(null)}>{t('Cancel')}</Button>
              <Button type="primary" onClick={copyCode}>
                {t('Copy invitation link')}
              </Button>
            </div>
          </div>
        ) : (
          <Form layout="vertical" form={form}>
            {loading && <Loading />}
            <Form.Item rules={[{ type: 'email' }, { required: true }]} required name="email" label={t('Email')}>
              <Input type="email" />
            </Form.Item>

            <div className="buttons">
              <Button onClick={() => setAmpToInvite(null)}>{t('Cancel')}</Button>
              <Button type="primary" onClick={onSubmit}>
                {t('Submit')}
              </Button>
            </div>
          </Form>
        )}
      </Style >
    </Modal >
  );
}
